<template>
  <div class="div-content">
    <img
      class="bg-img"
      src="@/assets/images/solution-header-bg.png"
    >
    <p class="p-text">{{ $tc('message.solution.head') }}</p>
    <p class="text-center">
      {{ $tc('message.solution.head1') }} <br />
      {{ $tc('message.solution.head2') }}</p>
  </div>
</template>

<script>
export default {
  name: "SolutionHeader",
};
</script>

<style lang="stylus" scoped>
.div-content {
  position: relative;

  .bg-img {
    width: 100%;
  }

  .p-text {
    font-weight: 400;
    position: absolute;
    font-size: 3.5rem;
    letter-spacing: 0.3rem;
    color: #fff;
    top: 25%;
    width: 100%;
    text-align: center !important;
  }

  .text-center {
    position: absolute;
    font-size: 1.5rem;
    letter-spacing: 0.3rem;
    color: #ffffff;
    top: 50%;
    width: 100%;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/solution/components/SolutionHeader.vue